<template>
  <div id="About">
    <Menu areWeinAbout="true"/>
    <!-- Header Inicio -->
    <div class="colorAzul">
      <section class="secImage1">
        <div class="fondotransparente">
          <h1>PROTECTION AND SECURITY RESEARCH INTELLIGENCE CONSULTANCY-RISK ANALYSIS</h1>
        </div>
      </section>
      <section class="secTexto">
        <div class="html">
          <h1 class="tituloContenidoInterno">
            <span>Grupo Glarus</span>
          </h1>
          <h2
            class="subtituloContenidoInterno"
          >Confidentiality, security and experience essential values at Grupo Glarus.</h2>
          <p class="parrafoContenidoInterno">
            Success in domestic and international operations requires management and development of security systems and qualified human capital to mitigate the risks.
            <br>
            <br>
            <span>Grupo Glarus</span> provides services in executive security and protection, intelligence on researches and consultancy on risks, which improves the capacity of a corporation or company to operate in a reliable and secure way in the current business environment.
            <br>
            <br>We have a wide network of contacts and collaborators in Mexico and abroad that provide us with valuable information and assist us in reliable researches and analysis for future ventures, thus creating links of experience, security and confidentiality with our clients.
          </p>
          <h3>OUR SERVICES:</h3>
          <ul class="listaContenidoInternoAbout">
            <li>EXECUTIVE TRANSPORTATION AND PROTECTION</li>
            <li>SECURITY LOGISTICS FOR EVENTS AND PRODUCTIONS</li>
            <li>RESEARCH AND INTELLIGENCE</li>
            <li>FRAUD DETECTION</li>
            <li>MONITORING AND COVERAGE FOR GUARDS</li>
            <li>LOGISTIC FOR GOODS AND MERCHANDISE</li>
            <li>TALKS AND CONSULTANCY ON PERSONAL SECURITY</li>
            <li>RISK CONSULTANCYRISK CONSULTANCY</li>
          </ul>
          <h3>PHILOSOPHY</h3>
          <p
            class="parrafoContenidoInterno"
          >Confidentiality and discretion towards our clients, as well as the services we provide for them are essential values for us, they define us and make us different and unique to our clients in terms of executive security and protection.</p>
          <h3>VISION</h3>
          <p
            class="parrafoResaltado"
          >Be the Mexican leading company in executive security, providing trust, protection, and most importantly; peace of mind to its domestic and foreign clients.</p>
          <h3>MISSION</h3>
          <p class="parrafoItalico">
            Our
            <span>raison d’être</span> is to protect and safeguard our clients, their families, their assets and businesses, all this by offering a wide range of protection and security services that fit the needs of our clients with a professional commitment, constant quality, good customer service, and through delivering the best experience in security services.
          </p>
        </div>
      </section>
      <section class="secImage2">
        <div class="ceoFrame">
          <h1>“The quality factor and confidentiality in what are we doing best supported by our expert human capital”</h1>
          <h3>PHILIPPE PARAVICINI</h3>
          <h4>CEO</h4>
        </div>
      </section>
    </div>

    <FooterComponent/>
  </div>
</template>

<script>
// @ is an alias to /src

import Menu from "@/components/Menu2.vue";
import FooterComponent from "@/components/Footer.vue";

//import image1 from '../assets/img/about/header_about.jpg';
//import image2 from '../assets/img/about/quienes_somos_frase.jpg';

export default {
  name: "About",
  data: function() {
    return {};
  },
  components: {
    Menu,
    FooterComponent
  },
  mounted: function() {
    this.$nextTick(function() {
      document.title = "About Us / Glarus";
    });
  }
};
</script>

<style lang="less" >
@import url("../assets/less/soloVariables.less");

.colorAzul {
  color: @color_Principal_Logo;
}

body,
html {
  min-height: 100%;
}
///
body {
  background-color: rgb(255, 255, 255);
}

//Header
section {
  box-sizing: border-box;
}
section.secImage1 {
  height: 80vh;

  background: url(../assets/img/about/header_about.jpg);
  background-size: cover;
  background-position: center center;
  background-attachment: fixed;

  width: 100vw;
}

section.secImage2 {
  height: 90vh;
  width: 100vw;
  background: url(../assets/img/about/quienes_somos_frase.jpg);
  background-size: cover;
  background-position: center center;
  background-attachment: fixed;
}

.secTexto {
  //height: 90vh;
  width: 100%;
  padding: 0px 20px;
  //height: 300px;
  background-color: white;
  .html {
    box-sizing: border-box;
    width: 100%;
    padding: 20px 30px;
    //border: 1px solid red;
    h3 {
      padding-top: 20px;
      @media @tablet {
        //border: 1px solid red;
        text-align: center;
        letter-spacing: 0.3em;
      }
    }
    .tituloContenidoInterno {
      //border: 1px solid red;
      color: @color_Principal_Logo;
      width: 38%;
      font-size: 1.5em;
      font-weight: 300;
      //padding: 20px 10px;
      //border-top: 0.5px solid @color_Principal_Logo;
      //border-bottom: 0.5px solid @color_Principal_Logo;
      @media @tablet {
        width: 48%;
      }

      @media @mobile {
        width: 88%;
      }
      span {
        display: inline-block;
        border-bottom: 1px solid @color_Principal_Logo;
        border-top: 1px solid @color_Principal_Logo;
        padding: 20px;
      }
    }

    .subtituloContenidoInterno {
      font-size: 1.5em;
      font-weight: 700;
      width: 60%;
      padding: 10px 0px;
      padding: 20px 0px;
      color: @color_Principal_Logo;
      @media @tablet {
        text-align: center;
        width: 90%;
        //border: 1px solid red;
      }
      @media @mobile {
        text-align: left;
        width: 100%;
      }
    }
    .parrafoResaltado {
      font-weight: 600;
      color: gray;
      line-height: 1.5em;
      //border: 1px solid red;
    }
    .parrafoItalico {
      //border: 1px solid red;
      color: gray;
      font-weight: 300;
      line-height: 1.6;
      span {
        font-style: italic;
      }
    }
    .parrafoContenidoInterno {
      //border: 1px solid red;
      color: rgb(136, 133, 133);
      font-weight: 300;
      line-height: 1.6;
      padding: 20px 0px;
      span {
        font-weight: bolder;
      }
    }
    .listaContenidoInternoAbout {
      //border: 1px solid red;
      padding-left: 20px;
      li {
        //border: 1px solid red;
        color: @color_Principal_Logo;
        font-size: 1.1em;
        font-weight: 600;

        line-height: 1.5em;
      }
    }
  }
}
.secImage2 {
  display: flex;
  flex-flow: column;
  justify-content: center;
}
.ceoFrame {
  display: flex;
  flex-flow: column;
  justify-content: flex-end;
  align-items: center;
  //border: 1px solid red;
  //box-sizing: border-box;

  //border: 1px solid red;
  //background-color: rgba(255, 255, 255, 1);

  @media @desktop-xl {
    margin: 40px 30px;
    width: 45%;
  }

  @media @desktop {
    width: 45%;
  }

  @media @tablet {
    margin: 40px 15px;

    margin-left: 30px;
    padding: 40px 15px;
    width: 70%;
    margin-left: 30px;
  }

  @media @mobile {
    margin: 40px 15px;
    width: 80%;
    margin: auto;
    background-color: rgba(255, 255, 255, 0.5);
  }

  h1 {
    color: @color_Principal_Logo;
    margin: auto;
    width: 60%;
    padding: 10px 0px;
    font-size: 2em;
    font-weight: 300;
    text-align: center;
    //border: 1px solid red;

    @media @desktop-xl {
      width: 60%;
    }

    @media @desktop {
      width: 79%;
      font-size: 1.8em;
      //width: 70%;
      padding: 0px 0px;
    }

    @media @tablet {
      font-size: 1.8em;
      //width: 70%;
      padding: 0px 0px;
    }

    @media @mobile {
      font-size: 1.8em;
      width: 90%;
    }
  }
  h3 {
    color: @color_Principal_Logo;
    //border: 1px solid red;
  }
  h4 {
    color: @color_Principal_Logo;
    // border: 1px solid red;
  }
}

.fondotransparente {
  //border: 1px solid red;
  display: flex;
  flex-flow: column;
  justify-content: center;

  width: 100%;
  height: 100%;
  background-color: rgba(4, 61, 114, 0.45);
  h1 {
    //border: 1px solid red;
    color: white;
    font-size: 2.1em;
    font-weight: 300;
    width: 55%;
    padding: 20px 40px;
    padding-top: 100px;

    @media @desktop-xl {
    }

    @media @desktop {
    }

    @media @tablet {
      text-align: left;
      font-size: 2.2em;
      width: 80%;
    }

    @media @mobile {
      text-align: center;
      font-size: 1.5em;
      width: 85%;
      padding: 20px 15px;
      padding-top: 100px;
    }
  }
}
</style>
